import { useLazyQuery } from '@apollo/client';
import { Button, Form } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import {
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
  USER_LIBRARY_TYPE,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import GoBackButton from '../../../../../components/GoBackButton';
import LoaderComponent from '../../../../../components/LoaderComponent';
import Portal from '../../../../../components/Portal';
import { USER } from '../../../graphql/Queries';
import EndUserForm from '../components/EndUserForm';
import EndUsersTabs from '../components/EndUsersTabs';

const ViewEndUser = ({
  match: { params: { id, userNumber } = {} } = {},
  isDrawerView = false,
  endUserId,
  endUserNumber,
}) => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [form] = Form.useForm();
  const history = useHistory();
  const [endUserDetail, setEndUserDetail] = useState({});
  const [isEndUserLoading, setIsEndUserLoading] = useState(true);

  const currentId = isDrawerView ? endUserId : id;
  const currentUserNumber = isDrawerView ? endUserNumber : userNumber;

  const [users] = useLazyQuery(USER, {
    onCompleted: (response) => {
      setEndUserDetail(response?.user);
      setIsEndUserLoading(false);
    },
    fetchPolicy: 'network-only',
    onError() {},
  });

  useEffect(() => {
    if (currentId) {
      setIsEndUserLoading(true);
      setEndUserDetail([]);
      users({
        variables: {
          where: {
            id: currentId,
          },
        },
      });
    }
  }, [currentId]);

  const primaryLibrary = endUserDetail?.userLibraries?.find(
    (lib) => lib?.type === USER_LIBRARY_TYPE?.PRIMARY?.value,
  );

  const initialValues = {
    ...endUserDetail,
    contact: endUserDetail?.contactNo,
    status: endUserDetail?.isActive,
    state: endUserDetail?.state,
    city: endUserDetail?.city,
    pincode: endUserDetail?.pincode?.pincode,
    id: endUserDetail?.userNumber,
    mappedLibrary:
      primaryLibrary?.library?.name || endUserDetail?.pincode?.library?.name,
    lat: endUserDetail?.latLong?.coordinates?.[1],
    lng: endUserDetail?.latLong?.coordinates?.[0],
    additionalAddress:
      endUserDetail?.additionalAddressDetails?.formattedAddress,
  };

  const EditUserButtons = () =>
    hasPermission(
      PERMISSIONS_KEY?.SYSTEM_USERS_END_USERS,
      PERMISSION_TYPE?.UPDATE,
      permissions,
    ) && (
      <div className="header-btn-wrapper">
        <Button
          className="common-button mr-16"
          size="middle"
          onClick={() =>
            history?.push(
              `${ROUTES?.SYSTEM_USERS}${ROUTES?.END_USERS}${ROUTES?.BASIC_DETAILS}/edit/${currentId}/${currentUserNumber}`,
            )
          }
        >
          Edit End User
        </Button>
      </div>
    );

  const contentComponent = isEndUserLoading ? (
    <LoaderComponent size="large" setHeight="60" spinning={isEndUserLoading} />
  ) : (
    <div className="endUser-form">
      <EndUserForm
        form={form}
        initialValues={initialValues}
        isView
        endUserDetail={endUserDetail}
      />
    </div>
  );

  if (isDrawerView) {
    return contentComponent;
  }

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton
          customLink={`${ROUTES?.SYSTEM_USERS}${ROUTES?.END_USERS}`}
        />
        <div className="portal-header">View End User</div>
      </Portal>
      <Portal portalId="header-right-content">
        <EditUserButtons />
      </Portal>
      <Portal portalId="header-right-content-phones">
        <EditUserButtons />
      </Portal>
      <EndUsersTabs
        endUserId={currentId}
        endUserNumber={currentUserNumber}
        onboardedOn={endUserDetail?.createdAt}
        isView
      >
        {contentComponent}
      </EndUsersTabs>
    </>
  );
};

export default ViewEndUser;
